import {
  Calculator, Scale, Monitor, Megaphone, Users, Shield, Building, Truck, TrendingUp, Sparkles,
} from "lucide-react";

export const CATEGORY_ICONS = {
  calculator: Calculator,
  scale: Scale,
  monitor: Monitor,
  megaphone: Megaphone,
  users: Users,
  shield: Shield,
  building: Building,
  truck: Truck,
  "trending-up": TrendingUp,
  sparkles: Sparkles,
};

export const CATEGORY_TINTS = {
  amber: { bg: "bg-amber-50", text: "text-[#F5A623]", border: "border-amber-200", soft: "bg-amber-100/60" },
  purple: { bg: "bg-purple-50", text: "text-purple-600", border: "border-purple-200", soft: "bg-purple-100/60" },
  blue: { bg: "bg-blue-50", text: "text-blue-600", border: "border-blue-200", soft: "bg-blue-100/60" },
  rose: { bg: "bg-rose-50", text: "text-rose-600", border: "border-rose-200", soft: "bg-rose-100/60" },
  emerald: { bg: "bg-emerald-50", text: "text-emerald-600", border: "border-emerald-200", soft: "bg-emerald-100/60" },
  indigo: { bg: "bg-indigo-50", text: "text-indigo-600", border: "border-indigo-200", soft: "bg-indigo-100/60" },
  slate: { bg: "bg-slate-100", text: "text-slate-700", border: "border-slate-200", soft: "bg-slate-200/60" },
  cyan: { bg: "bg-cyan-50", text: "text-cyan-600", border: "border-cyan-200", soft: "bg-cyan-100/60" },
  orange: { bg: "bg-orange-50", text: "text-orange-600", border: "border-orange-200", soft: "bg-orange-100/60" },
};

export const LABEL_STYLE = {
  populair: { bg: "bg-amber-100", text: "text-[#B7740A]" },
  wettelijk: { bg: "bg-rose-100", text: "text-rose-700" },
  nieuw: { bg: "bg-emerald-100", text: "text-emerald-700" },
};
